export const profileData = [
  {
    date: "20-10-20",
    name: "Amber Maelys Tatiana jouse",
    mobile: "8778726589",
    emiratesId: "7456549489495465",
    company: "Dulsco LLC",
    branchId: "41237",
    status: "Created",
  },
  {
    date: "10-10-20",
    name: "AmitGidadra pandit",
    mobile: "8778785890",
    emiratesId: "74569694489495465",
    company: "ARbec Holding PJLLC",
    branchId: "12470",
    status: "Rejected",
  },
  {
    date: "10-10-20",
    name: "AmitGidadra pandit",
    mobile: "8778785890",
    emiratesId: "74569694489495465",
    company: "ARbec Holding PJLLC",
    branchId: "12470",
    status: "Rejected",
  },
  {
    date: "10-10-20",
    name: "AmitGidadra pandit",
    mobile: "8778785890",
    emiratesId: "74569694489495465",
    company: "ARbec Holding PJLLC",
    branchId: "12470",
    status: "Rejected",
  },
  {
    date: "10-10-20",
    name: "AmitGidadra pandit",
    mobile: "8778785890",
    emiratesId: "74569694489495465",
    company: "ARbec Holding PJLLC",
    branchId: "12470",
    status: "Rejected",
  },
  {
    date: "10-10-20",
    name: "AmitGidadra pandit",
    mobile: "8778785890",
    emiratesId: "74569694489495465",
    company: "ARbec Holding PJLLC",
    branchId: "12470",
    status: "Rejected",
  },
  {
    date: "10-10-20",
    name: "AmitGidadra pandit",
    mobile: "8778785890",
    emiratesId: "74569694489495465",
    company: "ARbec Holding PJLLC",
    branchId: "12470",
    status: "Rejected",
  },
  {
    date: "10-10-20",
    name: "AmitGidadra pandit",
    mobile: "8778785890",
    emiratesId: "74569694489495465",
    company: "ARbec Holding PJLLC",
    branchId: "12470",
    status: "Rejected",
  },
  {
    date: "10-10-20",
    name: "AmitGidadra pandit",
    mobile: "8778785890",
    emiratesId: "74569694489495465",
    company: "ARbec Holding PJLLC",
    branchId: "12470",
    status: "Rejected",
  },
  {
    date: "10-10-20",
    name: "AmitGidadra pandit",
    mobile: "8778785890",
    emiratesId: "74569694489495465",
    company: "ARbec Holding PJLLC",
    branchId: "12470",
    status: "Rejected",
  },
  {
    date: "10-10-20",
    name: "AmitGidadra pandit",
    mobile: "8778785890",
    emiratesId: "74569694489495465",
    company: "ARbec Holding PJLLC",
    branchId: "12470",
    status: "Rejected",
  },
  {
    date: "10-10-20",
    name: "AmitGidadra pandit",
    mobile: "8778785890",
    emiratesId: "74569694489495465",
    company: "ARbec Holding PJLLC",
    branchId: "12470",
    status: "Rejected",
  },
];

export const transactionData = [
  {
    date: "20-10-20",
    name: "Amber Maelys Tatiana jouse",
    mobile: "8778726589",
    beneficiary: "Crosaint Baugette",
    Country: "India",
    Type: "Bank Transfer",
    sent_aed: "100.00",
    c3ref: "RMT0000084451",
    rakref: "16089784566+4",
    status: "Success",
  },
  {
    date: "10-10-20",
    name: "Amit Banga Tatiana Mousie",
    mobile: "9778726589",
    beneficiary: "Crosaints Jeget",
    Country: "USA",
    Type: "Bank Transfer",
    sent_aed: "100.00",
    c3ref: "RMT0000084451",
    rakref: "16089784566+4",
    status: "Reversed",
  },
];
export const ReachargetransactionData = [
  {
    date: "20-10-20",
    name: "Amber Maelys Tatiana jouse",
    sender: "9710264598",
    beneficiary: "Crosaint Baugette",
    receiver: "887985564",
    sent_aed: "100.00",
    c3ref: "RMT0000084451",
    status: "Success",
  },
  {
    date: "20-10-20",
    name: "Amber Maelys Tatiana jouse",
    sender: "9710264598",
    beneficiary: "Crosaint Baugette",
    receiver: "887985564",
    sent_aed: "100.00",
    c3ref: "RMT0000084451",
    status: "Success",
  },
  {
    date: "20-10-20",
    name: "Amber Maelys Tatiana jouse",
    sender: "9710264598",
    beneficiary: "Crosaint Baugette",
    receiver: "887985564",
    sent_aed: "100.00",
    c3ref: "RMT0000084451",
    status: "Success",
  },
  {
    date: "20-10-20",
    name: "Amber Maelys Tatiana jouse",
    sender: "9710264598",
    beneficiary: "Crosaint Baugette",
    receiver: "887985564",
    sent_aed: "100.00",
    c3ref: "RMT0000084451",
    status: "Success",
  },
];
export const RechargeTransactionData = [
  {
    date: "20-10-20",
    name: "Amber Maelys Tatiana jouse",
    mobile: "8778726589",
    beneficiary: "Crosaint Baugette",
    Receiver: "In97150124567",
    sent_aed: "100.00",
    c3ref: "RMT0000084451",
    status: "Success",
  },
  {
    date: "10-1-20",
    name: "Rober niclous petrova",
    mobile: "95508726589",
    beneficiary: "ruddy buck",
    Receiver: "In971589125667",
    sent_aed: "60.00",
    c3ref: "RMT00008464451",
    status: "Failed",
  },
];

export const ReferrerCodeData = [
  { date: "20-10-20", name: "Amber Maelys Tatiana jouse", code: "AMD123" },
  { date: "10-10-20", name: "Ambit Gidhari jones", code: "NVD103" },
  { date: "05-10-20", name: "Mohammad Aedhil Usair", code: "RYZ023" },
  { date: "20-10-20", name: "Amber Maelys Tatiana jouse", code: "AMD123" },
  { date: "10-10-20", name: "Ambit Gidhari jones", code: "NVD103" },
  { date: "05-10-20", name: "Mohammad Aedhil Usair", code: "RYZ023" },
  { date: "20-10-20", name: "Amber Maelys Tatiana jouse", code: "AMD123" },
  { date: "10-10-20", name: "Ambit Gidhari jones", code: "NVD103" },
  { date: "05-10-20", name: "Mohammad Aedhil Usair", code: "RYZ023" },
  { date: "20-10-20", name: "Amber Maelys Tatiana jouse", code: "AMD123" },
  { date: "10-10-20", name: "Ambit Gidhari jones", code: "NVD103" },
  { date: "05-10-20", name: "Mohammad Aedhil Usair", code: "RYZ023" },
  { date: "20-10-20", name: "Amber Maelys Tatiana jouse", code: "AMD123" },
  { date: "10-10-20", name: "Ambit Gidhari jones", code: "NVD103" },
  { date: "05-10-20", name: "Mohammad Aedhil Usair", code: "RYZ023" },
  { date: "20-10-20", name: "Amber Maelys Tatiana jouse", code: "AMD123" },
  { date: "10-10-20", name: "Ambit Gidhari jones", code: "NVD103" },
  { date: "05-10-20", name: "Mohammad Aedhil Usair", code: "RYZ023" },
  { date: "20-10-20", name: "Amber Maelys Tatiana jouse", code: "AMD123" },
  { date: "10-10-20", name: "Ambit Gidhari jones", code: "NVD103" },
  { date: "05-10-20", name: "Mohammad Aedhil Usair", code: "RYZ023" },
  { date: "20-10-20", name: "Amber Maelys Tatiana jouse", code: "AMD123" },
  { date: "10-10-20", name: "Ambit Gidhari jones", code: "NVD103" },
  { date: "05-10-20", name: "Mohammad Aedhil Usair", code: "RYZ023" },
  { date: "20-10-20", name: "Amber Maelys Tatiana jouse", code: "AMD123" },
  { date: "10-10-20", name: "Ambit Gidhari jones", code: "NVD103" },
  { date: "05-10-20", name: "Mohammad Aedhil Usair", code: "RYZ023" },
  { date: "20-10-20", name: "Amber Maelys Tatiana jouse", code: "AMD123" },
  { date: "10-10-20", name: "Ambit Gidhari jones", code: "NVD103" },
  { date: "05-10-20", name: "Mohammad Aedhil Usair", code: "RYZ050" },
];
